module.exports = __webpack_public_path__ + "media/images/help/schedule_daily-50bdccb13053f2642858251a47f7f59f.png";